import React, { useState, useEffect } from "react";
import { sendAppierConversion } from "../tracking/appier";
import { trackButtonClick, parseCurrentUriAds } from "../tracking/tracker";

export const Mycard = (props) => {
  const [links, setLinks] = useState({
    //line: "https://liff.line.me/2006508428-LaMj0Q6M",
    line: "line://app/2007605903-BR0b43NW?_ads=myc001_line",
    web: "https://play.bwd.tw/?_ads=myc001_web",
  });

  useEffect(() => {
    const { ads, ref } = parseCurrentUriAds();
    console.log("parseCurrentUriAds:", { ads, ref });

    // 若 ads 或 ref 有其一存在
    if (ads || ref) {
      setLinks((prevLinks) => {
        const updatedLinks = {};

        Object.keys(prevLinks).forEach((key) => {
          try {
            const url = new URL(prevLinks[key]);

            // 用真正的值分別設定 → 不會 double encode
            if (ads) url.searchParams.set("_ads", ads);
            if (ref) url.searchParams.set("ref", ref);

            updatedLinks[key] = url.toString();
          } catch (error) {
            console.error(`Error updating ${key} link:`, error.message);
            updatedLinks[key] = prevLinks[key]; // 保留原始連結
          }
        });

        return updatedLinks;
      });
    }
  }, []); // 空依賴陣列，只在初次渲染時執行

  return (
    <div id="mycard" >
      <div className="container">
        <br></br>
        <br></br>
        <br></br>
        <div className="section-title text-center">
          <h2>MyCard限定優惠</h2>
        </div>
        <div className="row">
          <h3>活動時間：</h3>
          <p>2026/2/2 ~ 2026/2/28</p>
          <br></br>

          <h3>活動內容：</h3>
          <p>活動期間內，以任意方式購買 MyCard 點數並成功儲值至遊戲內，最高可獲得回饋<b className="point"> 28% </b>遊戲幣，回饋自動發放無需申請。</p>
          <br></br>

          <h3>注意事項：</h3>
          <ul>
            <li>本活動採MyCard單筆儲值金額為判斷依據。</li>
            <li>本活動贈送之包含但不限遊戲虛寶、MyCard 點數及 MyCard 現金抵用券等，除有特別約定外， 限使用/兌換乙次，主辦及協辦單位有權就異常使用/兌換之遊戲及 MyCard 會員帳號進行凍結及為必要處理。</li>
            <li>遊戲帳號遭停權之玩家，不具參加本活動之資格</li>
            <li>參加本活動即視同同意本活動之活動辦法與注意事項之規範，與所有活動內 容及贈品、點數發送方式，主辦單位保留以上活動及獎項內容修改之權利， 並有權決定修改、取消、暫停或終止活動及贈送內容。</li>
            <li>本活動所有贈送之虛寶及點數均不得要求官方轉換、轉讓、折換現金或遊戲道具、貨幣。</li>
            <li>本遊戲分級屬限制級，相關參與及領取行為應符合法定年齡要件。任何活動 僅限年滿 18 歲以上玩家參加。</li>
            <li>除上述說明外，請詳閱<a href="https://www.mycard520.com.tw/ns_active/web/convention/event.html" target="blank">【其他注意事項】</a>內說明規範。</li>
          </ul>
        </div>
        <div className="col-md-12 intro-text">
          <a id="btn-header-line" href={links.line} className="btn btn-intro page-scroll" onClick={(e) => {
            sendAppierConversion("Conversion_2484");
            trackButtonClick(e.currentTarget);
          }}
          >
            <img src="img/intro-btn-line.png" className=" " alt="點LINE立即玩" />
          </a>{" "}
          <a id="btn-header-web" href={links.web} className="btn btn-intro page-scroll" onClick={(e) => {
            sendAppierConversion("Conversion_86ab");
            trackButtonClick(e.currentTarget);
          }}
          >
            <img src="img/intro-btn-web.png" className=" " alt="點網頁立即玩" />
          </a>{" "}
        </div>
      </div>
    </div>
  );
};
